import { render, staticRenderFns } from "./ProductPackages.vue?vue&type=template&id=b38da90e&scoped=true&"
import script from "./ProductPackages.vue?vue&type=script&lang=js&"
export * from "./ProductPackages.vue?vue&type=script&lang=js&"
import style0 from "./ProductPackages.vue?vue&type=style&index=0&id=b38da90e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38da90e",
  null
  
)

export default component.exports